module.exports = __webpack_public_path__ + "img/custom-item1-1.191a4eb.png";